import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export const GOAL_FIELDS = [
  ["new_ue", "AVGS: neue UE pro Monat (mindestens)", "UE"], ["billed_ue", "Abgerechnete UE pro Monat (mindestens)", "UE"],
  ["wb_tn", "FbW: neue Kunden pro Monat (mindestens)", "Kunden"], ["wb_classes", "FbW: neue Klassen pro Monat (mindestens)", "Klassen"],
  ["wb_min_tn", "FbW: Teilnehmer gesamt in Weiterbildung (mindestens)", "TN"], ["docs_pct", "Vollständige Teilnehmerunterlagen", "%"],
  ["completed_coachings", "Abgeschlossene Coachings pro Monat", "Anzahl"],
];
const monthLabel = (m) => (m ? `${m.slice(5, 7)}/${m.slice(0, 4)}` : "—");

export default function TraegerGoalsTab() {
  const [d, setD] = useState(null);
  const [f, setF] = useState({ valid_from: new Date().toISOString().slice(0, 7), goals: {} });
  const load = () => api.get("/traeger-center/goals").then((r) => {
    setD(r.data);
    setF((x) => ({ ...x, goals: Object.fromEntries(Object.entries(r.data.current.goals).map(([k, v]) => [k, v ?? ""])) }));
  });
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      await api.post("/traeger-center/goals", f);
      toast.success(`Ziele gültig ab ${monthLabel(f.valid_from)} gespeichert`);
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  const remove = async (v) => {
    if (!window.confirm(`Zielversion ab ${monthLabel(v.valid_from)} löschen?`)) return;
    await api.delete(`/traeger-center/goals/${v.valid_from}`);
    load();
  };
  if (!d) return <div className="text-xs text-slate-400">Lädt…</div>;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-6" data-testid="traeger-goals">
      <div className="border border-slate-200 bg-white p-5 space-y-3">
        <p className="text-xs text-slate-500">Neue Werte gelten ab dem gewählten Monat. Frühere Monate behalten ihre damaligen Ziele, damit Auswertungen nachvollziehbar bleiben. Das Team-Dashboard verwendet diese Werte automatisch.</p>
        <label className="flex items-center gap-3 text-sm text-slate-700">
          <span className="flex-1">Gültig ab Monat</span>
          <input type="month" value={f.valid_from} onChange={(e) => setF({ ...f, valid_from: e.target.value })} className="input-tech !w-44" data-testid="goal-valid-from" />
        </label>
        {GOAL_FIELDS.map(([k, l, u]) => (
          <label key={k} className="flex items-center gap-3 text-sm text-slate-700">
            <span className="flex-1 min-w-0">{l}</span>
            <input type="number" min="0" value={f.goals[k] ?? ""} onChange={(e) => setF({ ...f, goals: { ...f.goals, [k]: e.target.value } })} placeholder={["completed_coachings", "wb_classes", "wb_min_tn"].includes(k) ? "festlegen" : ""} className="input-tech !w-28 shrink-0 text-right" data-testid={`goal-${k}`} />
            <span className="w-14 text-xs text-slate-400">{u}</span>
          </label>
        ))}
        <button onClick={save} className="w-full bg-slate-900 text-white py-3 text-sm font-medium hover:bg-black" data-testid="goal-save">Ziele speichern</button>
      </div>
      <div className="border border-slate-200 bg-white" data-testid="goal-versions">
        <div className="px-5 py-3 border-b border-slate-100 text-[10px] font-bold uppercase tracking-overline text-slate-500">Zielversionen</div>
        {d.versions.length === 0 && <div className="p-5 text-sm text-slate-500">Noch keine eigenen Ziele – es gelten die Voreinstellungen.</div>}
        <ul className="divide-y divide-slate-100">{d.versions.map((v) => (
          <li key={v.valid_from} className="px-5 py-3 text-xs" data-testid={`goal-version-${v.valid_from}`}>
            <div className="flex items-center justify-between"><span className="font-medium text-slate-900 text-sm">ab {monthLabel(v.valid_from)}</span>
              <button onClick={() => remove(v)} className="text-slate-400 hover:text-red-600" data-testid={`goal-version-delete-${v.valid_from}`}><Trash2 size={13} /></button></div>
            <div className="text-slate-500 mt-1">{GOAL_FIELDS.map(([k, , u]) => `${v.goals[k] ?? "—"} ${u}`).join(" · ")}</div>
          </li>))}
        </ul>
      </div>
    </div>
  );
}
